import { FC, ReactNode } from 'react';
import useDesktopMediaQuery from '../hooks/use-desktop-media-query';

interface DesktopMediaQueryProps {
    children: ReactNode;
}

const DesktopMediaQuery: FC<DesktopMediaQueryProps> = (props) => {
    const { children } = props;

    const isDesktop = useDesktopMediaQuery();

    return isDesktop ? <>{children}</> : null;
};

export default DesktopMediaQuery;
